import React, { useState } from 'react';
import { Breadcrumb, Input, Button, Form, message, Row, Col, Select ,List} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
// import {  } from '../gqls'
import axios from 'axios';
import MemberItem from './memberItem'
const { TextArea } = Input;
const AppPushPage = (props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)
    const [membersList, setMembersList] = useState([]);
    const [members, setMembers] = useState();
    const [editMembers, setEditMembers] = useState();
    React.useEffect(() => {

    }, [])
    function onStart() {
        props.setNewKey('developerCenter/settings/profileSettings')
        navigate('/developerCenter/settings/profileSettings')
    }
    const layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };
    const onFinish = (values) => {
        console.log(values);
        if (values.usernames === undefined) {
            message.error('usernames不可为空,请输入推送用户')
        } else {
            grayScale(values, values.usernames.split(','))

        }
    };
    function grayScale(values, usernames) {
        setIsLoading(true)
        axios.post('https://test-notifications.ihealthlabs.com/pro-api/notifications/gray-scale'
            , {
                message: values.message,
                messageType: values.messageType,
                bigPictureUrl: values.bigPictureUrl,
                thumbnailUrl: values.thumbnailUrl,
                linkUrl: values.linkUrl,
                usernames: usernames,
                title: values.title,
                eventId: values.eventId,
                showType: values.showType,
                uniqueIdentifier: values.uniqueIdentifier
            }, {
            headers: {
                Un: values.Un,
            },
        }).then((res) => {
            console.log('grayScale:', res)
            if (res.data.Result === 1) {
                message.success('推送成功')
            } else {
                message.error(res.data.Msg)
            }
            setIsLoading(false)
        }).catch((error) => {
            setIsLoading(false)

        });
    }
    const onItemsMembersClick = (value) => {
        if (!members.includes(value)) {
            var list = []
            list = list.concat(members)
            list[members.length] = value
            setMembers(list)
        }

    };
    function onDeselectMembers(value) {
        console.log(value)
        var list = [{}]
        members.map((item, index) => {
            list[index] = item
        })
        list.splice(list.indexOf(value), 1)
        setMembers(list)
        console.log(list)
    }
    function onClearMembers() {
        setMembers([])
    }
    const removeMember=(name)=>{

    }
    return (
        <div style={{ height: '100%', width: '100%', }}>
            <div style={{ minHeight: '437px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                {/* 标题头 */}
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>Settings</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>AppPush</a></Breadcrumb.Item>
                </Breadcrumb>

                <div style={{ fontSize: '20px', marginLeft: '150px', marginTop: '30px', marginBottom: '34px' }}>
                    AppPush
                </div>
                <Form
                    {...layout}
                    name="nest-messages"
                    onFinish={onFinish}
                    style={{
                        maxWidth: 600,
                    }}
                >

                    <Form.Item name={'Un'} label="Un">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'message'} label="message">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'messageType'} label="messageType">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'bigPictureUrl'} label="bigPictureUrl">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'thumbnailUrl'} label="thumbnailUrl">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'linkUrl'} label="linkUrl">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'usernames'} label="usernames">
                        <div style={{
                            height: '35px', backgroundColor: '#fff', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                        }}>
                            <Select
                                className='select'
                                mode="multiple"
                                size='middle'
                                allowClear
                                style={{
                                    width: '100%',
                                }}
                                maxTagCount='responsive'
                                showArrow={true}
                                bordered={false}
                                placeholder="Please select"
                                onSelect={onItemsMembersClick}
                                options={membersList}
                                value={members}
                                onClear={onClearMembers}
                                onDeselect={onDeselectMembers}
                            />
                        </div>
                    </Form.Item>
                    <Form.Item name={'title'} label="title">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'eventId'} label="eventId">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'showType'} label="showType">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item name={'uniqueIdentifier'} label="uniqueIdentifier">
                        <TextArea autoSize />
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            ...layout.wrapperCol,
                            offset: 8,
                        }}
                    >
                        <Button htmlType="submit" disabled={isLoading} style={{
                            marginTop: '30px', marginLeft: '240px', marginBottom: '30px', height: '32px', width: '160px', color: '#fff',
                            background: '#FF5300', display: 'flex', justifyContent: 'center', alignItems: 'center',
                        }} >
                            <div style={{ display: isLoading ? 'none' : 'contents', color: '#FFFFFF' }}>Submit</div>
                            <div style={{ display: isLoading ? 'contents' : 'none', }}>
                                <img class='img' style={{ width: '20px', height: '20px' }} src={require('../../../../static/img/ic-login-loading.png')} />
                            </div>
                        </Button>
                    </Form.Item>
                </Form>
                <div style={{ fontSize: '20px', marginLeft: '150px', marginTop: '30px', marginBottom: '34px' }}>
                    白名单用户
                </div>
                <List
                    grid={{
                        gutter: 20,
                        column: 8,
                    }}
                    dataSource={editMembers}
                    renderItem={(item, index) => (
                    <MemberItem
                    name={item}
                    remove={removeMember}
                    />)}
                    style={{ marginTop: '20px', width: '1184px' }}
                />    
            </div>

        </div>
    );

}

export default AppPushPage